import styled from "styled-components";

import { Link as LinkPrimitive } from "ds/Button";

export const Link = styled(LinkPrimitive).attrs(() => ({ capitalized: false }))`
  margin-top: 8px;
`;

export default Link;
